import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { setIsLoading, setMessageLoading } from "store";
import Swal from "sweetalert2";
import {
    postGenerarConversionAudioActuacion,
    getLiberacionAudioActuacion,
    getAudioConvertidoActuacion,
} from "services/audioActuacionService/audioActuacionService";


import {
    onLoadConversionActuacion,
    onLoadLiberacionActuacion,
    onChangeLabelButtonConvertir
} from "store/audioActuaciones/audioActuacionSlice";//eslint-disable-next-line

import { BodyConversionAudioActuacion, BodyLiberacionAudioActuacion } from "interfaces/audioActuacion/audioActuacionInterfaces";


export const useAudioActuaciones = () => {
    const dispatch = useDispatch();
    const { dataConversionActuacion, dataLiberaActuacion, labelButtonConvertir } = useSelector(
        (state: RootState) => state.audioActuacionSlice
    );

    const startGetLiberacionActuacion = async (params: BodyLiberacionAudioActuacion) => {
        getLiberacionAudioActuacion(params)
            .then(({ data }) => {
                if (data?.data !== null) {
                    dispatch(onLoadLiberacionActuacion(data.data));
                    if(data?.data?.liberar === "S")
                    {
                        // revisar si ya se genero el audio
                        starGetAudioConvertidoActuacion(params);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Error al obtener la liberación de audio",
                });
            });
    };

    const startGenerarConversionAudioActuacion = async (params: BodyConversionAudioActuacion) => {
        dispatch(setIsLoading(true));
        dispatch(setMessageLoading("Generando audio"));
        dispatch(onChangeLabelButtonConvertir("Generando..."));
        postGenerarConversionAudioActuacion(params)
            .then(({ data }) => {
                if (data?.data !== null) {
                    dispatch(setIsLoading(false));
                    dispatch(setMessageLoading(""));
                    if(data?.data?.status === "SUCCESS")
                    {
                        dispatch(onLoadConversionActuacion(data.data));
                        dispatch(onChangeLabelButtonConvertir("Generar Audio"));
                    }
                    else if(data?.data?.status === "STARTED" || data?.data?.status === "PENDING")
                    {
                        // esperar 5 segundos y volver a consultar
                        setTimeout(() => {
                            dispatch(onChangeLabelButtonConvertir("Consultar Audio"));
                        }, 5000); 
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                dispatch(setIsLoading(false));
                dispatch(setMessageLoading(""));
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Error al obtener la conversión de audio",
                });
            });
    };

    
    const starGetAudioConvertidoActuacion = async (params: BodyConversionAudioActuacion) => {
        getAudioConvertidoActuacion(params)
            .then(({ data }) => {
                if (data !== null) {
                    if(data?.data !== null && data?.data?.cveEstatusConversion === 3)  // 3 es el estatus generado
                    {
                        dispatch(onLoadConversionActuacion(data?.data));
                    }
                }
            })
            .catch((err) => {
                console.log(err);
        });
    };


    return {
        dataConversionActuacion,
        dataLiberaActuacion,
        labelButtonConvertir,
        startGetLiberacionActuacion,
        startGenerarConversionAudioActuacion
    };


};